import React, { useState } from "react";
import { BsThreeDots } from "react-icons/bs";
import { IoMdArrowDropright } from "react-icons/io";
import { MdDelete, MdVerified } from "react-icons/md";
import { RiCloseCircleLine } from "react-icons/ri";
import { TbMathFunction } from "react-icons/tb";
import { useSelector, useDispatch } from "react-redux";
import {
  updateAggregate,
  deleteAggregate,
  deleteNodes,
  deleteEdges,
} from "../../store/reducers/etlSlice";
import { useEffect } from "react";
import { IoAlertCircleSharp } from "react-icons/io5";

const Aggregate = ({
  id,
  setNodes,
  setEdges,
  edges,
  setPopup,
  setData,
  setAggregateForm,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [removeNode, setRemoveNode] = useState(false);
  const [filled, setFilled] = useState(false);
  const dispatch = useDispatch();
  const EtlDetails = useSelector((state) => state.etl);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const ToNavigateSource = () => {
    //  window.location.href = '/Sourcetarget';
    setData(id);
    // setPopup(true);
    setAggregateForm(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    if (removeNode) {
      setRemoveNode(false);
    }
  };

  const deleteNode = () => {
    setNodes((elements) => elements.filter((element) => element.id !== id));
    // setEdges((elements) => elements.filter((element) => element.source !== id));
    let a = EtlDetails.edges.filter((element) => element.source === id);
    let b = EtlDetails.edges.filter((element) => element.target === id);

    if (EtlDetails.edges.length > 0) {
      let a1 = a[0]?.id;
      let b1 = b[0]?.id;
      dispatch(deleteEdges(a1));
      dispatch(deleteEdges(b1));
    }
    // dispatch(updateAggregate(id));
    if (EtlDetails.aggregate.length > 0) {
      dispatch(deleteAggregate(id));
    }
    dispatch(deleteNodes(id));
  };
  useEffect(() => {
    let a = EtlDetails.aggregate.some((e) => e.id === id);
    if (a === true) {
      setFilled(true);
    }
  }, [EtlDetails.aggregate]);
  return (
    <div style={{ marginTop: "-19px" }}>
      <span
        style={{
          fontSize: "7px",
          fontWeight: "bold",
          marginLeft: "-15px",
          // display: "flex",
          width: "200px",
          color: filled ? "green" : "red",
        }}
        className="d-flex align-items-center"
      >
        {filled ? (
          <>
            {" "}
            <MdVerified size={7} color="green" /> Aggregate
          </>
        ) : (
          <>
            {" "}
            <IoAlertCircleSharp size={7} color="red" />
            Aggregate
          </>
        )}
      </span>{" "}
      {isHovered ? (
        <div
          onMouseLeave={handleMouseLeave}
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            // className="d-flex align-items-center"
            style={{ fontSize: "7px", width: "10px", marginTop: "5px" }}
            onClick={ToNavigateSource}
          >
            <p
              style={{
                fontSize: "7px",
                display: "flex",
                alignItems: "center",
                width: "30px",
              }}
            >
              {" "}
              Open <IoMdArrowDropright />
            </p>
          </div>
          <div style={{ marginTop: "0px" }}>
            <BsThreeDots onClick={() => setRemoveNode((current) => !current)} />
            {removeNode && (
              <div
                style={{
                  display: "flex",
                  position: "relative",
                  left: "2px",
                  top: "0px",
                  zIndex: 1000,
                  border: "1px solid #ccc",
                  backgroundColor: "whitesmoke",
                  borderRadius: "5px",
                  minWidth: "25px",
                }}
              >
                <MdDelete color="red" onClick={deleteNode} />
                <RiCloseCircleLine
                  onClick={() => setRemoveNode((current) => !current)}
                />
                {/* </button> */}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div onClick={handleMouseEnter} style={{ marginTop: "8px" }}>
          <TbMathFunction size={14} />
        </div>
      )}
    </div>
  );
};

export default Aggregate;
